export default "__VITE_ASSET__BG1Z1RBu__"